import { Link } from "react-router-dom"
import "../css/Seneca.css"
import { useState } from "react"
import { RiDoubleQuotesL } from "react-icons/ri";

const Seneca = () => {
    const [activeTab, setActiveTab] = useState(0);

    const services = [
        {
            title: "Video-Acta",
            icon: "/images/seneca/videoacta.webp",
            image: "/images/seneca/videoacta(1).webp",
            alt: "videoacta",
            description: (
                <>
                    <p>Séneca permite que los Secretarios puedan certificar el vídeo y vincularlo al acta, generando una vídeo-acta. De esta forma, el vídeo se transforma en un diario literal de sesiones: Séneca gestiona la autenticidad e integridad de la vídeo-acta con la firma del Secretario mediante certificado digital o DNI-e, así como su validación pública.</p>

                    <p>En un solo documento, se guardan en el repositorio para ser consultados y contrastados con total transparencia. Séneca es la solución que hace más fácil la grabación y asegura la acreditación de su autenticidad e integridad por el Secretario.</p>
                </>
            )
        },
        {
            title: "Grabación y Catalogación",
            icon: "/images/seneca/grabacion-y-catalogacion.webp",
            image: "/images/seneca/grabacion-y-catalogacion(1).webp",
            alt: "grabacion y catalogación",
            description: (
                <>
                    <p>
                        Séneca permite la integración de la grabadora con su solución de microfonía y votación digital, lo cual hace innecesario mantener distintas bases de datos con la misma información para distintos sistemas. Nuestro software permite:
                    </p>

                    <ul>
                        <li>Controlar la configuración de los escaños.</li>
                        <li>Cargar distintas bases de oradores.</li>
                        <li>Registro automático de intervenciones de acuerdo a la actividad de los micrófonos.</li>
                        <li>Agregar contenido al servidor y catalogarlo con posterioridad.</li>
                        <li>Entrega de clips a los medios mientras se graba la sesión.</li>
                        <li>Presentación en web de una manera rápida dinámica.</li>
                        <li>Registro automático de intervenciones de acuerdo a la actividad de los micrófonos.</li>
                    </ul>
                </>
            )
        },
        {
            title: "Publicación",
            icon: "/images/seneca/publicacion.webp",
            image: "/images/seneca/publicacion(1).webp",
            alt: "publicación",
            description: (
                <>
                    <p>Séneca es un gestor de contenido multimedia que permite a los usuarios del sistema, internos o públicos, facilidades para buscar, acceder, compartir y difundir información:</p>

                    <ul>
                        <li><strong>Streaming:</strong> transmisión multicanal en directo de las sesiones que se realicen de manera simultánea, mediante streaming adaptativo y mutiplataforma.</li>
                        <li><strong>Videoteca:</strong> portal dinámico, organizado, ágil con formato de medio de comunicación y un buscador inteligente a través del contenido de los vídeos.</li>
                        <li><strong>Acceso a los oradores:</strong> accede directamente a las intervenciones de los oradores y busca por legislatura, órgano, grupo político.</li>
                        <li><strong>SpeechToText:</strong> proceso de extracción de texto del vídeo, que lo indexa junto al mismo y permite realizar búsquedas en los discursos.</li>
                        <li><strong>Catálogo multimedia y Actas:</strong> Obtenga material gráfico, textos, diarios de sesiones, boletines o cualquier contenido vinculado a la sesión. El secretario puede firmar el vídeo mediante DNI-e o certificado personal.</li>
                        <li><strong>Catálogo múltiple:</strong> Séneca permite gestionar otros contenidos como eventos, ruedas de prensa, presentaciones o actos patrocinados por la institución.</li>
                    </ul>
                </>
            )
        },
        {
            title: "Transcripción",
            icon: "/images/seneca/transcripcion.webp",
            image: "/images/seneca/transcripcion(1).webp",
            alt: "transcripción",
            description: (
                <>
                    <p>
                        Séneca es una solución definitiva para la organización y control del trabajo en grupo y una plataforma completa para el proceso de creación y gestión del diario de sesiones:
                    </p>

                    <ul>
                        <li><strong>Externalización</strong> disponible, total o parcial, solucionando picos de trabajo.</li>
                        <li><strong>Transcripción en directo:</strong> Las sesiones pueden transcribir en vivo, mientras tiene lugar la sesión, distribuyendo el trabajo entre los transcriptores y correctores seleccionados.</li>
                        <li><strong>Transcripción en diferido:</strong> Puede crear el trabajo de transcripción una vez finalizada la sesión.</li>
                        <li><strong>Vídeo Acta:</strong> Séneca gestiona la firma digital del vídeo mediante certificado digital o DNI-e, así el secretario puede asociar el vídeo de la sesión al acta de acuerdos.</li>
                        <li><strong>Panel de administración:</strong> El sistema incluye un completo panel de control para que el responsable del servicio pueda gestionar los trabajos ágilmente.</li>
                        <li><strong>Control de los transcriptores:</strong> Desde el panel, el supervisor podrá comprobar la carga de trabajo de cada uno de los transcriptores, individualmente, por equipo y por trabajo.</li>
                        <li><strong>Estado de las cintas:</strong> El panel de administración permite también verificar en qué situación está cada una de las cintas.</li>
                        <li><strong>Aplicación de escritorio:</strong> Se conecta y sincroniza con las tareas del usuario y permite controlar el trabajo de manera más directa y rápida para los transcriptores avanzados.</li>
                        <li><strong>SpeechToText:</strong> potente herramienta de conversión de voz a texto, esta transcripción está disponible para ser usada por el transcriptor y es accesible sincronizada con la cinta que esté en proceso.</li>
                    </ul>
                </>
            )
        },
        {
            title: "Administración",
            icon: "/images/seneca/administracion.webp",
            image: "/images/seneca/administracion(1).webp",
            alt: "administración",
            description: (
                <>
                    <p>
                        Séneca dispone un backend web completo y de fácil manejo, para gestionar de forma eficaz usuarios, roles, contenidos y procesos:
                    </p>

                    <ul>
                        <li><strong>Usuarios:</strong> El sistema permite la asignación de diferentes roles, con distintos niveles de acceso, que determinan la capacidad de uso y edición de los distintos módulos de Séneca.</li>
                        <li><strong>Configuración:</strong> El despliegue de Séneca puede realizarse con infraestructura propia o bien como servicio en cloud. En ambos supuestos el control de la plataforma es total por parte del usuario.</li>
                        <li><strong>Catálogo:</strong> estructura completamente configurable por el usuario a través de los ítems o sesiones en el entorno legislativo. Estos podrán contener varias grabaciones de vídeo, audio, fotos, notas de prensa, diarios, boletines o cualquier contenido vinculado a la sesión.</li>
                        <li><strong>Categorías:</strong> Además de la jerarquía legislativa que incorpora por defecto, Séneca permite la creación de otras categorías libres para ordenar otros contenidos como eventos, ruedas de prensa, etc.</li>
                        <li><strong>Canales:</strong> los ítems o sesiones que sean homogéneos también pueden agruparse en canales para un acceso directo desde la galería.</li>
                        <li><strong>Etiquetas:</strong> Séneca permite la creación de etiquetas libres para asignarse a cualquier ítem.</li>
                        <li><strong>Auditoría:</strong> herramientas internas que permiten auditar el funcionamiento de las colas de tareas. Un registro de todo lo que pasa en Séneca, desde información de tracking hasta errores del software.</li>
                    </ul>
                </>
            )
        },
        {
            title: "Servicios",
            icon: "/images/seneca/servicios.webp",
            image: "/images/seneca/servicios(1).webp",
            alt: "servicios",
            description: (
                <>
                    <p>
                        Es posible que no se necesiten todas las funcionalidades de Séneca, por lo que queremos ofrecer la posibilidad de adaptarlas a sus necesidades y contratarlas como servicios:
                    </p>

                    <p>
                        Producción y streaming: ofrecemos un servicio llave en mano para retransmitir sus actos de empresa o institucionales: nosotros nos encargamos de todo, simplemente fije fecha, lugar y duración del evento. Nuestro Kit de Grabación incluye: operario, cámara, gestión y emisión.
                        Transcripción y Traducción: cuente con un equipo de transcriptores y traductores profesionales 24 horas al día, para convertir sus vídeos en texto.
                    </p>
                </>
            )
        }
    ];

    const parlamentos = [
        {
            name: "Parlamento de Galicia",
            image: "/images/parlamentos/galicia.webp"
        },
        {
            name: "Parlamento de La Rioja",
            image: "/images/parlamentos/rioja.webp"
        },
        {
            name: "Cortes Valencianas",
            image: "/images/parlamentos/valencia.webp"
        },
        {
            name: "Cortes de Aragón",
            image: "/images/parlamentos/aragon.webp"
        },
        {
            name: "Parlamento de Andalucía",
            image: "/images/parlamentos/andalucia.webp"
        },
        {
            name: "Cortes de Castilla Y León",
            image: "/images/parlamentos/castillaleon.webp"
        },
        {
            name: "Parlamento de Navarra",
            image: "/images/parlamentos/navarra.webp"
        },
        {
            name: "Asamblea de Madrid",
            image: "/images/parlamentos/madrid.webp"
        },
        {
            name: "Junta general del principado de Asturias",
            image: "/images/parlamentos/asturias.webp"
        }
    ]

    const ayuntamientos = [
        {
            name: "Ayuntamiento de Andratx",
            image: "/images/ayuntamientos/andratx.webp"
        },
        {
            name: "Atuntamiento de Cáceres",
            image: "/images/ayuntamientos/caceres.webp"
        },
        {
            name: "Diputación de Cádiz",
            image: "/images/ayuntamientos/diputacion-de-cadiz.webp"
        },
        {
            name: "Diputación de León",
            image: "/images/ayuntamientos/diputacion-de-leon.webp"
        },
        {
            name: "Ayuntamiento de Chiclana",
            image: "/images/ayuntamientos/chiclana.webp"
        },
        {
            name: "Ayuntamiento de Figueres",
            image: "/images/ayuntamientos/figueres.webp"
        },
        {
            name: "Ayuntamiento de Camargo",
            image: "/images/ayuntamientos/camargo.webp"
        },
        {
            name: "Ayuntamiento de Valladolid",
            image: "/images/ayuntamientos/valladolid.webp"
        },
        {
            name: "Ayuntamiento de Móstoles",
            image: "/images/ayuntamientos/mostoles.webp"
        },
        {
            name: "Concello de Porriño",
            image: "/images/ayuntamientos/porrino.webp"
        },
        {
            name: "Concello de Sada",
            image: "/images/ayuntamientos/sada.webp"
        },
        {
            name: "Ayuntamiento de San Roque",
            image: "/images/ayuntamientos/sanroque.webp"
        },
        {
            name: "Ayuntamiento de Sant VicenÇ dels Horts",
            image: "/images/ayuntamientos/santvicenc.webp"
        },
        {
            name: "Ayuntamiento de Valverde",
            image: "/images/ayuntamientos/valverde.webp"
        },
        {
            name: "Cabildo del Hierro",
            image: "/images/ayuntamientos/cab-hierro.webp"
        },
        {
            name: "Ayuntamiento de Badia del Vallés",
            image: "/images/ayuntamientos/badia-del-valles.webp"
        },
        {
            name: "Diputación de la Coruña",
            image: "/images/ayuntamientos/dip-coruna.webp"
        },
        {
            name: "Cabildo de Tenerife",
            image: "/images/ayuntamientos/cab-tenerife.webp"
        },
        {
            name: "Diputación de Guadalajara",
            image: "/images/ayuntamientos/dip-guadalajara.webp"
        },
        {
            name: "Juntas Generales de Álava",
            image: "/images/ayuntamientos/juntas-generales-de-alava.webp"
        },
        {
            name: "Juntas Generales de Gipuzkoa",
            image: "/images/ayuntamientos/juntas-generales-de-gipuzkoa.webp"
        }
    ]

    return (
        <div id="seneca" className="vw70">
            <section id="seneca-description">
                <article>

                    <h2 className="seneca-color seneca-title"> Software para la gestión de contenidos audiovisuales y video-actas</h2>

                    <p>
                        Séneca está desarrollado para la gestión y publicación en internet de grabaciones y archivos multimedia. Se trata de una herramienta para facilitar la comunicación entre las instituciones y el ciudadano, un software para transmitir de manera directa y sin intermediarios el mensaje, la postura y la coherencia de cada una de las ideas.
                    </p>

                    <div id="quoteContainer">
                        <RiDoubleQuotesL className="seneca-color" />
                        <p id="quote">
                            20 años trabajando con parlamentos, diputaciones y municipios nos han permitido aportar y compartir objetivos y desarrollar tecnologías que mejoran el trabajo de la administración institucional.
                        </p>
                    </div>
                    <Link className="seneca-link" to="https://www.seneca.tv/" >Más información en www.seneca.tv</Link>
                </article>

                <img loading="lazy" className="w100" src="/images/seneca.webp" alt="Servicio Seneca" />
            </section>

            <section id="seneca_services">
                <h2 className="seneca-color seneca-title" style={{ "textAlign": "center" }}>¿Qué ofrece Séneca?</h2>

                <div className="tabs-container col flex acenter gap-10">
                    <div className="tabs-header flex w100 gap-10">
                        {services.map((service, index) => (
                            <div key={index} className={`tab-head flex col acenter br8 ${activeTab === index ? 'active ' : ''}`} onClick={() => setActiveTab(index)}>
                                <img loading="lazy" src={service.icon} alt={service.alt} />
                                <span>{service.title}</span>
                            </div>
                        ))}
                    </div>

                    <div className="tabs-content">
                        {services.map((service, index) => (

                            (activeTab === index) ?
                                <div key={index} className={`tab-content pad-10 br8 ${activeTab === index ? 'active' : ''}`}>
                                    <h4 style={{ "fontSize": "30px" }}>{service.title}</h4>
                                    <div className="serviceBody w100">
                                        <div>
                                            {service.description}
                                        </div>
                                        <img className="w100" loading="lazy" src={service.image} alt={service.alt} />
                                    </div>
                                </div>
                                : <></>
                        ))}
                    </div>
                </div>
            </section>

            <section id="seneca_institutions">
                <h2 className="seneca-color seneca-title" style={{ "textAlign": "center" }}>¿Qué instituciones trabajan con Séneca?</h2>
                <article>
                    <h3 className="spica-color" style={{ "fontSize": "1.6em" }}>Parlamentos</h3>

                    <div className="parlamentos">
                        {parlamentos.map((parlamento, index) => (
                            <img loading="lazy" key={index} src={parlamento.image} alt={parlamento.name} />
                        ))}
                    </div>
                </article>

                <article>
                    <h3 className="spica-color" style={{ "fontSize": "1.6em" }}>Ayuntamientos y diputaciones</h3>
                    <div className="ayuntamientos">
                        {ayuntamientos.map((ayuntamiento, index) => (
                            <img loading="lazy" key={index} src={ayuntamiento.image} alt={ayuntamiento.name} />
                        ))}
                    </div>
                </article>
            </section>

        </div>
    )
}

export default Seneca
